import { imgUrl } from "@/lib/api";
import { ImageOff } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Foto que aguenta não existir.
 *
 * Duas coisas que todo lugar do sistema precisava fazer e nem todos faziam:
 *
 * 1. PASSAR PELO `imgUrl`. Foto enviada pelo admin é gravada como
 *    `/api/files/...`, e sem o prefixo o navegador resolve esse caminho contra
 *    o domínio de quem está exibindo — 404 silencioso.
 * 2. TER ALTERNATIVA. Sem foto, `imgUrl` devolve vazio, e `<img src="">` o
 *    navegador trata como imagem QUEBRADA: aparece o ícone de falha e, quando
 *    há `alt`, o texto dele no lugar da imagem. Era isso que fazia o nome do
 *    produto aparecer dentro da moldura, como se fosse legenda — o mesmo
 *    sintoma que apareceu nas categorias da home.
 *
 * O `alt` só é usado quando há foto de verdade. Sem ela quem entra é o
 * placeholder, marcado como decorativo: anunciar "imagem de Cadeira de Rodas"
 * para um quadrado cinza informa errado.
 */
export default function Thumb({ src, alt = "", icon: Icon = ImageOff, className, iconSize = 20 }) {
  const url = imgUrl(src);

  if (!url) {
    return (
      <div className={cn("bg-slate-100 grid place-items-center text-slate-300", className)} aria-hidden>
        <Icon size={iconSize} />
      </div>
    );
  }

  return <img src={url} alt={alt} className={className} />;
}
